/*
 * Til Death World – Luster theme
 * Custom JavaScript. Loaded via snippets/theme-globals.liquid.
 */

(function() {
  // Format trademark symbols (™ ®) into superscripts in target elements
  function formatTrademarkSymbols() {
    const trademarkRegex = /[™®]/g;
    const targetSelectors = [
      '.product-item__product-title',
      '.product__title',
      '.image-hero__text-container-heading',
      '.accordion__content',
      '.accordion__content p',
      '.video-hero__text-container-heading',
      '.image-hero__text-container-text',
      '.video-hero__text-container-text',
      '.header__links-list',
      '.product-tabs__tab-item-content'
    ];

    const elements = document.querySelectorAll(targetSelectors.join(','));

    elements.forEach(element => {
      const textNodes = [];
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return trademarkRegex.test(node.textContent)
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_REJECT;
          }
        },
        false
      );

      let node;
      while ((node = walker.nextNode())) {
        textNodes.push(node);
      }

      textNodes.forEach(node => {
        const span = document.createElement('span');
        span.className = 'trademark';
        span.innerHTML = node.textContent.replace(
          trademarkRegex,
          match => `<sup>${match}</sup>`
        );
        node.parentNode.replaceChild(span, node);
      });
    });
  }

  formatTrademarkSymbols();

  // Handle variant option color swatches in capture phase: update select and dispatch change
  // so the theme only sees the change event. Avoids theme click path that can trigger
  // full section refresh (innerHTML replace) and feel like a page reload.
  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest && evt.target.closest(
      '.product__variants-wrapper [data-option-buttons] .product__color-swatch[data-button][data-option-handle]'
    );
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    var group = btn.closest('[data-option-buttons]');
    var select = group && group.querySelector('select');
    if (!select) return;
    var optionHandle = btn.getAttribute('data-option-handle');
    if (!optionHandle) return;
    var opt = Array.from(select.options).find(function (o) {
      return o.getAttribute('data-value-handle') === optionHandle;
    });
    if (!opt) return;
    group.querySelectorAll('[data-button]').forEach(function (b) {
      b.classList.toggle('selected', b.getAttribute('data-option-handle') === optionHandle);
    });
    opt.selected = true;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  // Ensure option change events have srcElement so theme's onOptionChange doesn't throw (theme uses srcElement, not target).
  // Synthetic change events from swatch clicks may not have srcElement; run in capture phase before the theme's listener.
  document.addEventListener('change', function (evt) {
    if (!evt.target || !evt.target.name || evt.target.name.indexOf('options') !== 0) return;
    if (evt.srcElement !== undefined) return;
    try {
      Object.defineProperty(evt, 'srcElement', { value: evt.target, configurable: true });
    } catch (e) { /* ignore if read-only */ }
  }, true);

  // ---------------------------------------------------------------------------
  // Variant popout (custom dropdown for product variant options)
  // Replaces native <select> when JS is enabled; syncs to hidden input for ProductForm.
  // Phase B: MTO status labels when popout opens; line item property synced on init/variant change.
  // ---------------------------------------------------------------------------
  function getMTOData() {
    const el = document.querySelector('[data-variant-made-to-order-metafield]');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return [];
    }
  }

  /**
   * Default lead time from theme settings (Product > Made to order), normalized in Liquid.
   * @returns {string}
   */
  function getMTODefaultLeadTime() {
    var el = document.querySelector('[data-mto-default-lead-time]');
    var val = el ? (el.getAttribute('data-mto-default-lead-time') || '').trim() : '';
    return val || '4-6 wks';
  }

  var MTO_LINE_ITEM_PROPERTY_NAME = 'properties[Made to order]';
  var MTO_PROPERTY_LABEL = 'Made to order';
  var mtoCartScrubInProgress = false;
  var mtoAllowCheckoutSubmit = false;

  /**
   * In-stock check aligned with quick-cart / cart-item-properties Liquid.
   * Untracked inventory (no inventory_management) is treated as in stock.
   * @param {{ inventory_management?: string|null, inventory_quantity?: number }} data
   * @returns {boolean}
   */
  function isVariantInStockForMTO(data) {
    if (!data) return false;
    var invMgmt = data.inventory_management;
    if (invMgmt == null || invMgmt === '') return true;
    return Number(data.inventory_quantity) > 0;
  }

  /**
   * Cart/checkout line item property value for a variant's MTO entry.
   * Only return lead time when OOS with continue selling.
   * @param {Object|null} entry - MTO JSON entry for one variant
   * @returns {string} Normalized MTO value for cart, or '' when in stock / sold out / no MTO
   */
  function getMadeToOrderPropertyValue(entry) {
    if (!entry) return '';
    if (isVariantInStockForMTO(entry)) return '';
    if (entry.inventory_policy !== 'continue' && Number(entry.inventory_quantity) < 1) return '';
    var mtoVal = (entry.made_to_order_value && entry.made_to_order_value.trim())
      ? entry.made_to_order_value.trim()
      : getMTODefaultLeadTime();
    if (!mtoVal || mtoVal.toLowerCase().startsWith('in stock')) return '';
    return mtoVal;
  }

  /**
   * Enable or disable the hidden MTO input so empty values are not submitted to cart.
   * @param {HTMLInputElement|null} mtoInput
   * @param {string} propertyValue
   */
  function updateMadeToOrderLineItemInput(mtoInput, propertyValue) {
    if (!mtoInput) return;
    var hasValue = !!(propertyValue && propertyValue.trim());
    mtoInput.value = hasValue ? propertyValue.trim() : '';
    if (hasValue) {
      if (!mtoInput.getAttribute('name')) {
        mtoInput.setAttribute(
          'name',
          mtoInput.getAttribute('data-mto-property-name') || MTO_LINE_ITEM_PROPERTY_NAME
        );
      }
      mtoInput.disabled = false;
    } else {
      if (mtoInput.getAttribute('name')) {
        mtoInput.setAttribute('data-mto-property-name', mtoInput.getAttribute('name'));
        mtoInput.removeAttribute('name');
      }
      mtoInput.disabled = true;
    }
  }

  /**
   * Sync #made-to-order from MTO JSON for the given variant id.
   * @param {number|string} variantId
   */
  function syncMadeToOrderLineItemProperty(variantId) {
    var mtoInput = document.getElementById('made-to-order');
    if (!mtoInput || variantId == null || variantId === '') return;
    var mtoData = getMTOData();
    var entry = mtoData.find(function (v) { return Number(v.variant_id) === Number(variantId); });
    updateMadeToOrderLineItemInput(mtoInput, getMadeToOrderPropertyValue(entry));
  }

  function findVariantByOptionValues(variantsList, optionValues) {
    if (!variantsList || !variantsList.length) return null;
    function optionMatches(vOpt, ourVal) {
      var vBlank = vOpt == null || vOpt === '';
      var weOmit = ourVal == null || ourVal === '';
      if (weOmit) return vBlank;
      return vOpt === ourVal;
    }
    return variantsList.find(function (v) {
      return optionMatches(v.option1, optionValues[0]) &&
        optionMatches(v.option2, optionValues[1]) &&
        optionMatches(v.option3, optionValues[2]);
    }) || null;
  }

  /**
   * Resolve selected variant id for MTO sync (options wrapper, form id input, or data attr).
   * @param {HTMLFormElement|null} form
   * @returns {string|null}
   */
  function getVariantIdForMtoSync(form) {
    var productRoot = form
      ? (form.closest('[data-section-type="product"]') || form.closest('.product'))
      : null;
    var wrapper = productRoot && productRoot.querySelector('.product__variants-wrapper');
    if (wrapper) {
      var variants = getProductVariants(wrapper);
      if (variants && variants.length) {
        var currentSelections = getCurrentSelectionsFromWrapper(wrapper);
        var optionValues = [
          currentSelections.option1 || '',
          currentSelections.option2 || '',
          currentSelections.option3 || ''
        ];
        var titlePartsFiltered = optionValues.filter(function (p) { return p != null && p !== ''; });
        var variant = findVariantByOptionValues(variants, titlePartsFiltered);
        if (variant && variant.id != null) return String(variant.id);
      }
    }
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) return idInput.value;
      if (form.dataset.currentProductId) return form.dataset.currentProductId;
    }
    var select = document.querySelector('[data-product-form] select[name="id"]')
      || document.querySelector('select[name="id"][data-variant-select]')
      || document.querySelector('select[name="id"]');
    return select ? select.value : null;
  }

  function syncMadeToOrderForProductForm(form) {
    syncMadeToOrderLineItemProperty(getVariantIdForMtoSync(form));
  }

  function shouldKeepMadeToOrderCartProperty(variant) {
    if (!variant) return true;
    if (isVariantInStockForMTO(variant)) return false;
    if (!variant.available && variant.inventory_policy !== 'continue') return false;
    return true;
  }

  function fetchProductJson(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('product fetch failed');
      return res.json();
    });
  }

  function removeMadeToOrderPropertyFromLineItem(item) {
    var props = Object.assign({}, item.properties || {});
    delete props[MTO_PROPERTY_LABEL];
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties: props
      })
    }).then(function (res) { return res.json(); });
  }

  /**
   * Remove stale Made to order properties from cart line items that are in stock.
   * Ensures checkout/order data matches cart display rules.
   * @param {Object|null} cart
   * @returns {Promise<Object|null>}
   */
  function scrubStaleMadeToOrderCartProperties(cart) {
    if (mtoCartScrubInProgress) {
      return cart ? Promise.resolve(cart) : fetch('/cart.js').then(function (r) { return r.json(); });
    }
    var cartPromise = cart
      ? Promise.resolve(cart)
      : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });

    return cartPromise.then(function (currentCart) {
      if (!currentCart || !currentCart.items || !currentCart.items.length) return currentCart;

      var itemsWithMto = currentCart.items.filter(function (item) {
        return item.properties && item.properties[MTO_PROPERTY_LABEL];
      });
      if (!itemsWithMto.length) return currentCart;

      mtoCartScrubInProgress = true;
      return Promise.all(itemsWithMto.map(function (item) {
        return fetchProductJson(item.handle).then(function (product) {
          var variant = (product.variants || []).find(function (v) {
            return Number(v.id) === Number(item.variant_id);
          });
          if (shouldKeepMadeToOrderCartProperty(variant)) return null;
          return removeMadeToOrderPropertyFromLineItem(item);
        }).catch(function () { return null; });
      })).then(function (results) {
        if (results.some(function (r) { return r != null; })) {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
            .then(function (freshCart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshCart } }));
              document.dispatchEvent(new CustomEvent('quick-cart:updated'));
              return freshCart;
            });
        }
        return currentCart;
      }).finally(function () {
        mtoCartScrubInProgress = false;
      });
    });
  }

  function initMadeToOrderLineItemProperty() {
    document.addEventListener('product:variant-change', function (evt) {
      var variant = evt && evt.detail && evt.detail.variant;
      if (variant && variant.id != null) {
        syncMadeToOrderLineItemProperty(variant.id);
      }
    });

    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      syncMadeToOrderForProductForm(form);
      form.addEventListener('submit', function () {
        syncMadeToOrderForProductForm(form);
      }, true);
    });

    document.addEventListener('cart:updated', function (evt) {
      var cart = evt && evt.detail && evt.detail.cart;
      scrubStaleMadeToOrderCartProperties(cart);
    });
    document.addEventListener('cart:item-added', function () {
      scrubStaleMadeToOrderCartProperties();
    });
    document.addEventListener('quick-cart:open', function () {
      scrubStaleMadeToOrderCartProperties();
    });

    document.addEventListener('click', function (evt) {
      if (mtoAllowCheckoutSubmit) return;
      var btn = evt.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!btn) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      scrubStaleMadeToOrderCartProperties().finally(function () {
        mtoAllowCheckoutSubmit = true;
        btn.click();
        mtoAllowCheckoutSubmit = false;
      });
    }, true);

    scrubStaleMadeToOrderCartProperties();
  }

  /**
   * Get product variants JSON from the variant picker (when dynamic product options are enabled).
   * @param {HTMLElement} wrapper - .product__variants-wrapper
   * @returns {Array|null} Variants array or null if not present
   */
  function getProductVariants(wrapper) {
    if (!wrapper) return null;
    const el = wrapper.querySelector('[data-variant-json]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  /**
   * Build per-option lists of { value, soldOut } with in-stock items first.
   * Mirrors theme's createAvailableOptionsTree logic but sorts each option list so available come first.
   * @param {Array} variants - Product variants from data-variant-json
   * @param {Object} currentlySelectedValues - { option1: string, option2: string, option3: string }
   * @returns {Object} { option1: [{ value, soldOut }], option2: [...], option3: [...] }
   */
  function buildOptionsTreeSortedByStock(variants, currentlySelectedValues) {
    var optionKeys = ['option1', 'option2', 'option3'];
    var tree = { option1: [], option2: [], option3: [] };
    variants.forEach(function (variant) {
      optionKeys.forEach(function (index) {
        var val = variant[index];
        if (val == null) return;
        var entry = tree[index].find(function (o) { return o.value === val; });
        if (!entry) {
          entry = { value: val, soldOut: true };
          tree[index].push(entry);
        }
        var opt1 = currentlySelectedValues.option1;
        var opt2 = currentlySelectedValues.option2;
        var inStock = variant.available;
        if (index === 'option1') {
          if (inStock) entry.soldOut = false;
        } else if (index === 'option2') {
          if (opt1 && variant.option1 === opt1 && inStock) entry.soldOut = false;
        } else if (index === 'option3') {
          if (opt1 && variant.option1 === opt1 && opt2 && variant.option2 === opt2 && inStock) entry.soldOut = false;
        }
      });
    });
    optionKeys.forEach(function (k) {
      tree[k].sort(function (a, b) {
        if (a.soldOut === b.soldOut) return 0;
        return a.soldOut ? 1 : -1;
      });
    });
    return tree;
  }

  /**
   * Get current selected values for each option from the wrapper's selects.
   * @param {HTMLElement} wrapper - .product__variants-wrapper
   * @returns {Object} { option1: string, option2: string, option3: string }
   */
  function getCurrentSelectionsFromWrapper(wrapper) {
    var out = { option1: '', option2: '', option3: '' };
    if (!wrapper) return out;
    [1, 2, 3].forEach(function (pos) {
      var sel = wrapper.querySelector('select#option' + pos);
      if (sel) out['option' + pos] = sel.value || '';
    });
    return out;
  }

  /**
   * Reorder a native <select> so options appear in sorted order (in-stock first). Preserves selected value.
   * @param {HTMLSelectElement} select
   * @param {Array} sortedOptions - [{ value, soldOut }, ...]
   */
  function reorderSelectOptions(select, sortedOptions) {
    if (!select || !sortedOptions.length) return;
    var selectedVal = select.value;
    var optionsByValue = {};
    Array.from(select.options).forEach(function (opt) {
      optionsByValue[opt.value] = opt;
    });
    var order = sortedOptions.map(function (o) { return o.value; });
    order.forEach(function (val) {
      var opt = optionsByValue[val];
      if (opt) select.appendChild(opt);
    });
    if (selectedVal) select.value = selectedVal;
  }

  /**
   * Reorder popout list <li> items so in-stock options appear first. Preserves active state.
   * @param {HTMLElement} popout - .variant-popout
   * @param {Array} sortedOptions - [{ value, soldOut }, ...]
   */
  function reorderPopoutList(popout, sortedOptions) {
    var list = popout && popout.querySelector('[data-popout-list]');
    if (!list || !sortedOptions.length) return;
    var itemsByValue = {};
    list.querySelectorAll('.variant-popout__item').forEach(function (li) {
      var btn = li.querySelector('[data-popout-option]');
      if (btn) itemsByValue[btn.getAttribute('data-value')] = li;
    });
    var order = sortedOptions.map(function (o) { return o.value; });
    order.forEach(function (val) {
      var li = itemsByValue[val];
      if (li) list.appendChild(li);
    });
  }

  /**
   * Reorder all variant dropdowns and popout lists in the wrapper so in-stock options appear first.
   * Uses variant JSON when present (dynamic product options). No-op if no variant data.
   * @param {HTMLElement} wrapper - .product__variants-wrapper
   */
  function reorderVariantOptionsInStockFirst(wrapper) {
    if (!wrapper) return;
    var variants = getProductVariants(wrapper);
    if (!variants || !variants.length) return;
    var current = getCurrentSelectionsFromWrapper(wrapper);
    var tree = buildOptionsTreeSortedByStock(variants, current);
    [1, 2, 3].forEach(function (pos) {
      var key = 'option' + pos;
      var sorted = tree[key];
      if (!sorted || !sorted.length) return;
      var select = wrapper.querySelector('select#' + key);
      if (select) reorderSelectOptions(select, sorted);
      var popouts = wrapper.querySelectorAll('.variant-popout[data-option-position="' + pos + '"]');
      popouts.forEach(function (p) { reorderPopoutList(p, sorted); });
    });
  }

  function setPopoutRowStatuses(popout, mtoData) {
    if (!mtoData || !mtoData.length) return;
    const list = popout.querySelector('[data-popout-list]');
    const optionPos = parseInt(popout.getAttribute('data-option-position'), 10);
    if (!list) return;

    const wrapper = popout.closest('.product__variants-wrapper');
    if (!wrapper) return;
    const allPopouts = Array.from(wrapper.querySelectorAll('.variant-popout'))
      .filter(function (p) { return p.querySelector('select'); })
      .sort(function (a, b) {
        return (parseInt(a.getAttribute('data-option-position'), 10) || 0) - (parseInt(b.getAttribute('data-option-position'), 10) || 0);
      });

    // Only show statuses (In Stock / Made to order / Sold out) on the last select/option in the wrapper.
    // That way any product with a dropdown (Size, Carat, etc.) gets the status on its last option.
    const lastPopout = allPopouts.length ? allPopouts[allPopouts.length - 1] : null;
    if (popout !== lastPopout) {
      list.querySelectorAll('.variant-popout__status').forEach(function (statusEl) {
        statusEl.textContent = '';
      });
      return;
    }

    if (isNaN(optionPos)) return;
    const variants = getProductVariants(wrapper);
    var currentSelections = getCurrentSelectionsFromWrapper(wrapper);
    var currentValues = [
      currentSelections.option1 || '',
      currentSelections.option2 || '',
      currentSelections.option3 || ''
    ];
    const defaultMTO = 'Made to order (' + getMTODefaultLeadTime() + ')';

    function findMTOInfoByTitle(mtoList, titleParts) {
      if (!mtoList || !mtoList.length || !titleParts) return null;
      var joined = titleParts.join(' / ');
      var exact = mtoList.find(function (v) { return v.variant_title === joined; });
      if (exact) return exact;
      var joinedTrim = joined.trim();
      var normalized = mtoList.find(function (v) {
        return (v.variant_title && v.variant_title.trim() === joinedTrim);
      });
      if (normalized) return normalized;
      if (titleParts.length === 1 && titleParts[0]) {
        var single = mtoList.find(function (v) {
          if (!v.variant_title) return false;
          var t = v.variant_title.trim();
          return t === titleParts[0] || t === joinedTrim;
        });
        if (single) return single;
      }
      var parts = joined.split(/\s*\/\s*/).map(function (p) { return p.trim(); });
      return mtoList.find(function (v) {
        if (!v.variant_title) return false;
        var vParts = v.variant_title.split(/\s*\/\s*/).map(function (p) { return p.trim(); });
        if (vParts.length !== parts.length) return false;
        return parts.every(function (p, i) { return vParts[i] === p; });
      }) || null;
    }

    list.querySelectorAll('.variant-popout__item').forEach(function (item) {
      const btn = item.querySelector('[data-popout-option]');
      const statusEl = item.querySelector('.variant-popout__status');
      if (!btn || !statusEl) return;
      const rowValue = btn.getAttribute('data-value');
      if (rowValue == null) return;
      const titleParts = currentValues.slice();
      titleParts[optionPos - 1] = rowValue;
      var titlePartsFiltered = titleParts.filter(function (p) { return p != null && p !== ''; });
      const variant = variants ? findVariantByOptionValues(variants, titlePartsFiltered) : null;
      var variantInfo = variant
        ? mtoData.find(function (v) { return Number(v.variant_id) === variant.id; })
        : null;
      if (!variantInfo) variantInfo = findMTOInfoByTitle(mtoData, titlePartsFiltered);
      var statusText;
      if (!variantInfo) {
        statusText = defaultMTO;
      } else if (isVariantInStockForMTO(variantInfo)) {
        statusText = 'In Stock';
      } else if (variantInfo.inventory_policy !== 'continue' && variantInfo.inventory_quantity < 1) {
        statusText = 'Sold out';
      } else {
        var mtoVal = (variantInfo.made_to_order_value && variantInfo.made_to_order_value.trim())
          ? variantInfo.made_to_order_value.trim()
          : '';
        if (mtoVal && mtoVal.toLowerCase().startsWith('in stock')) {
          statusText = 'In Stock';
        } else {
          statusText = mtoVal ? ('Made to order (' + mtoVal + ')') : defaultMTO;
        }
      }
      statusEl.textContent = statusText;
    });
  }

  function applyInStockFirstOrderToAllWrappers() {
    document.querySelectorAll('.product__variants-wrapper').forEach(function (wrapper) {
      reorderVariantOptionsInStockFirst(wrapper);
    });
  }

  function initVariantPopouts() {
    const popouts = document.querySelectorAll('.variant-popout');
    if (!popouts.length) return;

    const LIST_VISIBLE_CLASS = 'variant-popout__list--visible';

    function isListVisible(popout) {
      const list = popout.querySelector('[data-popout-list]');
      return list && list.classList.contains(LIST_VISIBLE_CLASS);
    }

    function openList(popout) {
      const toggle = popout.querySelector('[data-popout-toggle]');
      const list = popout.querySelector('[data-popout-list]');
      if (!toggle || !list) return;
      toggle.setAttribute('aria-expanded', 'true');
      list.hidden = false;
      list.classList.add(LIST_VISIBLE_CLASS);
      positionList(popout);
      setPopoutRowStatuses(popout, getMTOData());
      document.addEventListener('click', closeOnClickOutside);
      document.addEventListener('keydown', closeOnEscape);
    }

    function closeList(popout) {
      const toggle = popout.querySelector('[data-popout-toggle]');
      const list = popout.querySelector('[data-popout-list]');
      if (!toggle || !list) return;
      toggle.setAttribute('aria-expanded', 'false');
      list.classList.remove(LIST_VISIBLE_CLASS);
      list.hidden = true;
      document.removeEventListener('click', closeOnClickOutside);
      document.removeEventListener('keydown', closeOnEscape);
    }

    function closeOnClickOutside(evt) {
      popouts.forEach(function (popout) {
        if (isListVisible(popout) && !popout.contains(evt.target)) {
          closeList(popout);
        }
      });
    }

    function closeOnEscape(evt) {
      if (evt.code !== 'Escape') return;
      popouts.forEach(function (popout) {
        if (isListVisible(popout)) {
          closeList(popout);
          popout.querySelector('[data-popout-toggle]').focus();
        }
      });
    }

    function positionList(popout) {
      const list = popout.querySelector('[data-popout-list]');
      if (!list) return;
      const toggle = popout.querySelector('[data-popout-toggle]');
      const rect = toggle.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      list.classList.toggle('variant-popout__list--top', spaceBelow < list.scrollHeight && spaceAbove > spaceBelow);
    }

    function selectOption(popout, value, optionEl) {
      const select = popout.querySelector('.variant-popout__select-wrap select');
      const toggleText = popout.querySelector('[data-popout-toggle-text]');
      if (!select || !toggleText) return;

      var opt = Array.from(select.options).find(function (o) { return o.value === value; });
      if (opt) opt.selected = true;
      toggleText.textContent = value;

      var optionWrapper = popout.closest('[data-product-option]');
      if (optionWrapper) {
        var pos = popout.getAttribute('data-option-position');
        var labelSpan = optionWrapper.querySelector('[data-selected-value-for-option][data-option-name="option' + pos + '"]');
        if (labelSpan) labelSpan.textContent = value;
      }

      popout.querySelectorAll('.variant-popout__item').forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });
      if (optionEl) {
        var item = optionEl.closest('.variant-popout__item');
        if (item) {
          item.classList.add('is-active');
          item.setAttribute('aria-selected', 'true');
        }
      }

      select.dispatchEvent(new Event('change', { bubbles: true }));

      closeList(popout);
    }

    popouts.forEach(function (popout) {
      var toggle = popout.querySelector('[data-popout-toggle]');
      var list = popout.querySelector('[data-popout-list]');
      if (!toggle || !list) return;

      toggle.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (isListVisible(popout)) {
          closeList(popout);
        } else {
          popouts.forEach(function (p) {
            if (isListVisible(p)) closeList(p);
          });
          openList(popout);
        }
      });

      popout.querySelectorAll('[data-popout-option]').forEach(function (btn) {
        btn.addEventListener('click', function (evt) {
          evt.preventDefault();
          var val = btn.getAttribute('data-value');
          if (val != null) selectOption(popout, val, btn);
        });
      });
    });

    // Sync popout display when variant changes from outside (e.g. URL, another option, theme logic)
    document.addEventListener('product:variant-change', function (evt) {
      popouts.forEach(function (popout) {
        var select = popout.querySelector('.variant-popout__select-wrap select');
        var toggleText = popout.querySelector('[data-popout-toggle-text]');
        if (!select || !toggleText) return;
        var value = select.value;
        toggleText.textContent = value;
        var optionWrapper = popout.closest('[data-product-option]');
        if (optionWrapper) {
          var pos = popout.getAttribute('data-option-position');
          var labelSpan = optionWrapper.querySelector('[data-selected-value-for-option][data-option-name="option' + pos + '"]');
          if (labelSpan) labelSpan.textContent = value;
        }
        popout.querySelectorAll('.variant-popout__item').forEach(function (item) {
          var btn = item.querySelector('[data-popout-option]');
          var match = btn && btn.getAttribute('data-value') === value;
          item.classList.toggle('is-active', !!match);
          item.setAttribute('aria-selected', match ? 'true' : 'false');
        });
      });
      // Defer reorder so theme finishes price/URL/variant updates before we reorder option DOM
      setTimeout(applyInStockFirstOrderToAllWrappers, 0);
    });

    // Reorder dropdowns so in-stock options appear first (initial load and whenever any option changes).
    // Defer reorder so it runs after the theme's change handler (variant lookup + price update); otherwise
    // reordering the option DOM can interfere with price updates when selecting MTO/sold-out variants.
    applyInStockFirstOrderToAllWrappers();
    document.addEventListener('change', function (evt) {
      var target = evt.target;
      if (!target || !target.name || target.name.indexOf('options[') !== 0) return;
      var wrapper = target.closest && target.closest('.product__variants-wrapper');
      if (wrapper) {
        var w = wrapper;
        setTimeout(function () { reorderVariantOptionsInStockFirst(w); }, 0);
      }
    });
  }

  function initCustomProductEnhancements() {
    initVariantPopouts();
    initMadeToOrderLineItemProperty();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomProductEnhancements);
  } else {
    initCustomProductEnhancements();
  }
})();
